// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");

function Make(Collection) {
  var sideEffectGroup_encode = function (encoder_sideEffect, v) {
    if (typeof v === "number") {
      return ["NoSideEffects"];
    }
    switch (v.TAG | 0) {
      case /* SingleSideEffect */0 :
          return [
                  "SingleSideEffect",
                  Curry._1(encoder_sideEffect, v._0)
                ];
      case /* SerialSideEffects */1 :
          return [
                  "SerialSideEffects",
                  Curry._2(Collection.t_encode, encoder_sideEffect, v._0)
                ];
      case /* ParallelSideEffects */2 :
          return [
                  "ParallelSideEffects",
                  Curry._2(Collection.t_encode, encoder_sideEffect, v._0)
                ];
      
    }
  };
  var sideEffectGroup_decode = function (decoder_sideEffect, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
      return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */3) {
      return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
      return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */0) {
      switch (match._0) {
        case "NoSideEffects" :
            if (tagged.length !== 1) {
              return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
            } else {
              return {
                      TAG: /* Ok */0,
                      _0: /* NoSideEffects */0
                    };
            }
        case "ParallelSideEffects" :
            if (tagged.length !== 2) {
              return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
            }
            var v0 = Curry._2(Collection.t_decode, decoder_sideEffect, Belt_Array.getExn(jsonArr$1, 1));
            if (v0.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* ParallelSideEffects */2,
                        _0: v0._0
                      }
                    };
            }
            var e = v0._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[0]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
        case "SerialSideEffects" :
            if (tagged.length !== 2) {
              return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
            }
            var v0$1 = Curry._2(Collection.t_decode, decoder_sideEffect, Belt_Array.getExn(jsonArr$1, 1));
            if (v0$1.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* SerialSideEffects */1,
                        _0: v0$1._0
                      }
                    };
            }
            var e$1 = v0$1._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[0]" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
        case "SingleSideEffect" :
            if (tagged.length !== 2) {
              return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
            }
            var v0$2 = Curry._1(decoder_sideEffect, Belt_Array.getExn(jsonArr$1, 1));
            if (v0$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* SingleSideEffect */0,
                        _0: v0$2._0
                      }
                    };
            }
            var e$2 = v0$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[0]" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
        default:
          
      }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
  };
  var stringify = function (stringifySideEffect, sideEffectGroup) {
    if (typeof sideEffectGroup === "number") {
      return "NoSideEffects";
    }
    switch (sideEffectGroup.TAG | 0) {
      case /* SingleSideEffect */0 :
          return Curry._1(stringifySideEffect, sideEffectGroup._0);
      case /* SerialSideEffects */1 :
          return "SerialSideEffects(" + (Curry._2(Collection.stringify, stringifySideEffect, sideEffectGroup._0) + ")");
      case /* ParallelSideEffects */2 :
          return "ParallelSideEffects(" + (Curry._2(Collection.stringify, stringifySideEffect, sideEffectGroup._0) + ")");
      
    }
  };
  var map = function (mapSideEffect, sideEffectGroup) {
    if (typeof sideEffectGroup === "number") {
      return /* NoSideEffects */0;
    }
    switch (sideEffectGroup.TAG | 0) {
      case /* SingleSideEffect */0 :
          return {
                  TAG: /* SingleSideEffect */0,
                  _0: Curry._1(mapSideEffect, sideEffectGroup._0)
                };
      case /* SerialSideEffects */1 :
          return {
                  TAG: /* SerialSideEffects */1,
                  _0: Curry._2(Collection.map, mapSideEffect, sideEffectGroup._0)
                };
      case /* ParallelSideEffects */2 :
          return {
                  TAG: /* ParallelSideEffects */2,
                  _0: Curry._2(Collection.map, mapSideEffect, sideEffectGroup._0)
                };
      
    }
  };
  var find_opt = function (predicate, sideEffectGroup) {
    if (typeof sideEffectGroup === "number") {
      return ;
    }
    switch (sideEffectGroup.TAG | 0) {
      case /* SingleSideEffect */0 :
          var sideEffect = sideEffectGroup._0;
          if (Curry._1(predicate, sideEffect)) {
            return Caml_option.some(sideEffect);
          } else {
            return ;
          }
      case /* SerialSideEffects */1 :
      case /* ParallelSideEffects */2 :
          return Curry._2(Collection.find_opt, predicate, sideEffectGroup._0);
      
    }
  };
  var isEmpty = function (sideEffectGroup) {
    if (typeof sideEffectGroup === "number") {
      return false;
    }
    switch (sideEffectGroup.TAG | 0) {
      case /* SingleSideEffect */0 :
          return false;
      case /* SerialSideEffects */1 :
      case /* ParallelSideEffects */2 :
          return Curry._1(Collection.isEmpty, sideEffectGroup._0);
      
    }
  };
  var execute = function (execSideEffect, sideEffectGroup) {
    if (typeof sideEffectGroup === "number") {
      return Promise.resolve(undefined);
    }
    switch (sideEffectGroup.TAG | 0) {
      case /* SingleSideEffect */0 :
          return Curry._2(execSideEffect, (function (sideEffect) {
                        return {
                                TAG: /* SingleSideEffect */0,
                                _0: sideEffect
                              };
                      }), sideEffectGroup._0);
      case /* SerialSideEffects */1 :
          return Curry._3(Collection.fold_left, (function (promiseChain, sideEffect) {
                        return promiseChain.then(function (param) {
                                    return Curry._2(execSideEffect, (function (sideEffect) {
                                                  return {
                                                          TAG: /* SerialSideEffects */1,
                                                          _0: Curry._1(Collection.make, sideEffect)
                                                        };
                                                }), sideEffect);
                                  });
                      }), Promise.resolve(undefined), sideEffectGroup._0);
      case /* ParallelSideEffects */2 :
          return Promise.all($$Array.of_list(Curry._1(Collection.toList, Curry._2(Collection.map, Curry._1(execSideEffect, (function (sideEffect) {
                                          return {
                                                  TAG: /* ParallelSideEffects */2,
                                                  _0: Curry._1(Collection.make, sideEffect)
                                                };
                                        })), sideEffectGroup._0)))).then(function (param) {
                      return Promise.resolve(undefined);
                    });
      
    }
  };
  return {
          sideEffectGroup_encode: sideEffectGroup_encode,
          sideEffectGroup_decode: sideEffectGroup_decode,
          stringify: stringify,
          map: map,
          find_opt: find_opt,
          isEmpty: isEmpty,
          execute: execute
        };
}

function stringify(stringifyElement, sideEffects) {
  return StringUtils$SmartcutsMacros.join(", ", List.map(stringifyElement, sideEffects));
}

function sideEffectGroup_encode(encoder_sideEffect, v) {
  if (typeof v === "number") {
    return ["NoSideEffects"];
  }
  switch (v.TAG | 0) {
    case /* SingleSideEffect */0 :
        return [
                "SingleSideEffect",
                Curry._1(encoder_sideEffect, v._0)
              ];
    case /* SerialSideEffects */1 :
        return [
                "SerialSideEffects",
                Decco.listToJson(encoder_sideEffect, v._0)
              ];
    case /* ParallelSideEffects */2 :
        return [
                "ParallelSideEffects",
                Decco.listToJson(encoder_sideEffect, v._0)
              ];
    
  }
}

function sideEffectGroup_decode(decoder_sideEffect, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "NoSideEffects" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NoSideEffects */0
                  };
          }
      case "ParallelSideEffects" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.listFromJson(decoder_sideEffect, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ParallelSideEffects */2,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "SerialSideEffects" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.listFromJson(decoder_sideEffect, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SerialSideEffects */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "SingleSideEffect" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Curry._1(decoder_sideEffect, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SingleSideEffect */0,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$1(stringifySideEffect, sideEffectGroup) {
  if (typeof sideEffectGroup === "number") {
    return "NoSideEffects";
  }
  switch (sideEffectGroup.TAG | 0) {
    case /* SingleSideEffect */0 :
        return Curry._1(stringifySideEffect, sideEffectGroup._0);
    case /* SerialSideEffects */1 :
        return "SerialSideEffects(" + (stringify(stringifySideEffect, sideEffectGroup._0) + ")");
    case /* ParallelSideEffects */2 :
        return "ParallelSideEffects(" + (stringify(stringifySideEffect, sideEffectGroup._0) + ")");
    
  }
}

function map(mapSideEffect, sideEffectGroup) {
  if (typeof sideEffectGroup === "number") {
    return /* NoSideEffects */0;
  }
  switch (sideEffectGroup.TAG | 0) {
    case /* SingleSideEffect */0 :
        return {
                TAG: /* SingleSideEffect */0,
                _0: Curry._1(mapSideEffect, sideEffectGroup._0)
              };
    case /* SerialSideEffects */1 :
        return {
                TAG: /* SerialSideEffects */1,
                _0: List.map(mapSideEffect, sideEffectGroup._0)
              };
    case /* ParallelSideEffects */2 :
        return {
                TAG: /* ParallelSideEffects */2,
                _0: List.map(mapSideEffect, sideEffectGroup._0)
              };
    
  }
}

function find_opt(predicate, sideEffectGroup) {
  if (typeof sideEffectGroup === "number") {
    return ;
  }
  switch (sideEffectGroup.TAG | 0) {
    case /* SingleSideEffect */0 :
        var sideEffect = sideEffectGroup._0;
        if (Curry._1(predicate, sideEffect)) {
          return Caml_option.some(sideEffect);
        } else {
          return ;
        }
    case /* SerialSideEffects */1 :
    case /* ParallelSideEffects */2 :
        return List.find_opt(predicate, sideEffectGroup._0);
    
  }
}

function isEmpty(sideEffectGroup) {
  if (typeof sideEffectGroup === "number") {
    return false;
  }
  switch (sideEffectGroup.TAG | 0) {
    case /* SingleSideEffect */0 :
        return false;
    case /* SerialSideEffects */1 :
    case /* ParallelSideEffects */2 :
        return List.length(sideEffectGroup._0) === 0;
    
  }
}

function execute(execSideEffect, sideEffectGroup) {
  if (typeof sideEffectGroup === "number") {
    return Promise.resolve(undefined);
  }
  switch (sideEffectGroup.TAG | 0) {
    case /* SingleSideEffect */0 :
        return Curry._2(execSideEffect, (function (sideEffect) {
                      return {
                              TAG: /* SingleSideEffect */0,
                              _0: sideEffect
                            };
                    }), sideEffectGroup._0);
    case /* SerialSideEffects */1 :
        return List.fold_left((function (promiseChain, sideEffect) {
                      return promiseChain.then(function (param) {
                                  return Curry._2(execSideEffect, (function (sideEffect) {
                                                return {
                                                        TAG: /* SerialSideEffects */1,
                                                        _0: {
                                                          hd: sideEffect,
                                                          tl: /* [] */0
                                                        }
                                                      };
                                              }), sideEffect);
                                });
                    }), Promise.resolve(undefined), sideEffectGroup._0);
    case /* ParallelSideEffects */2 :
        return Promise.all($$Array.of_list(List.map(Curry._1(execSideEffect, (function (sideEffect) {
                                    return {
                                            TAG: /* ParallelSideEffects */2,
                                            _0: {
                                              hd: sideEffect,
                                              tl: /* [] */0
                                            }
                                          };
                                  })), sideEffectGroup._0))).then(function (param) {
                    return Promise.resolve(undefined);
                  });
    
  }
}

var List$1 = {
  sideEffectGroup_encode: sideEffectGroup_encode,
  sideEffectGroup_decode: sideEffectGroup_decode,
  stringify: stringify$1,
  map: map,
  find_opt: find_opt,
  isEmpty: isEmpty,
  execute: execute
};

exports.Make = Make;
exports.List = List$1;
/* StringUtils-SmartcutsMacros Not a pure module */
